import {
  Box, Container, Flex, Divider, Heading, Text,
} from '@chakra-ui/react';
import { ArrowForwardIcon } from '@chakra-ui/icons';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { generate } from 'shortid';
import { HalfByHalfSection, LinkOne } from '../_index';
import House4 from '../../assets/houses/house-04.svg';
import FlareGroup5 from '../../assets/shapes/shape-group-5.svg';

const calculation = [
  '[After Repair Value]',
  '- [Cost Of Repairs]',
  '- [Our Selling Costs]',
  '- [Our Minimum Profit]',
];

const exampleValue = [
  'After Repair Value = $600k',
  'Cost of Repair = $80k',
  'Our Selling Cost = 10% * $600k = $60k',
  'Minimum Profit = $40k',
];

const example = ['$600k', '- $80k', '- $60k', '- $40k'];

const LeftBlock = () => (
  <Box>
    <Heading
      zIndex="1"
      as="h4"
      size="3xl"
    >
      Check The Math
    </Heading>
    <Heading
      as="h5"
      size="lg"
      variant="sec"
    >
      This is our real formula for how we calculate your offer
    </Heading>
    <LinkOne
      mt={4}
      to="/how-it-works/#glossary"
      icon={<ArrowForwardIcon />}
    >
      Glossary Of Terms
    </LinkOne>
  </Box>
);

const RightBlock = ({ img }) => (
  <Box
    zIndex="0"
    className="height-300"
    pb={10}
  >
    <Box
      position="relative"
      width="20rem"
      mx="auto"
      className="height-300"
      transform={{ base: 'scale(.7)', md: 'scale(1)' }}
    >
      {/* <Box
        position="absolute"
        opacity={0.8}
        zIndex="1"
        top="-20%"
        left="-5%"
      >
        <House4 className="width-200 height-300 flip-x" />
      </Box> */}
      <Box
        position="absolute"
        opacity={0.8}
        top="-20%"
        left="-20%"
      >
        <FlareGroup5 className="width-500 height-500  flip-y" />
      </Box>
      <Box
        position="absolute"
        top="-20%"
        left="20%"
      >
        <GatsbyImage
          className="width-300"
          alt="happy home buyers image"
          image={img}
        />
      </Box>
    </Box>
  </Box>
);

const CheckMath = () => {
  const { flareImage } = useStaticQuery(query);
  const image = getImage(flareImage);
  return (
    <Box
      backgroundColor="gray.200"
      py={20}
    >
      <Container maxW="container.xl">
        <HalfByHalfSection
          left={<LeftBlock />}
          right={<RightBlock img={image} />}
        />
        <Box
          backgroundColor="gray.300"
          px={4}
          py={10}
          rounded="lg"
        >
          <Heading
            as="h5"
            size="lg"
          >
            The Formula
          </Heading>
          <Flex
            mt={10}
            flexWrap="
            wrap"
          >
            {calculation.map((c, i) => (
              <Text
                key={generate()}
                fontSize="2xl"
              >
                {c}
              </Text>
            ))}
            <Text
              fontSize="2xl"
              fontWeight="semibold"
            >
              {' '}
              = Your Offer
            </Text>
          </Flex>
          <Divider my={10} />
          <Heading
            as="h5"
            size="lg"
            mb={4}
          >
            Example
          </Heading>
          <Flex
            mt={10}
            flexWrap="
            wrap"
            flexDir="column"
          >
            {exampleValue.map((c, i) => (
              <Text
                key={generate()}
                fontSize="2xl"
              >
                {c}
              </Text>
            ))}
            <Divider
              my={4}
              width="40%"
            />
            <Flex
              my={4}
              flexWrap="
            wrap"
            >
              {calculation.map((c, i) => (
                <Text
                  key={generate()}
                  fontSize="2xl"
                >
                  {c}
                </Text>
              ))}
              <Text
                fontSize="2xl"
                fontWeight="semibold"
              >
                {' '}
                = Your Offer
              </Text>
            </Flex>
            <Flex
              flexWrap="
            wrap"
            >
              {example.map((c, i) => (
                <Text
                  key={generate()}
                  fontSize="2xl"
                >
                  {c}
                </Text>
              ))}
              <Text
                fontSize="2xl"
                fontWeight="semibold"
              >
                {' '}
                = $420k
              </Text>
            </Flex>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
};

export const query = graphql`
  query {
    flareImage: file(relativePath: { eq: "business-woman-circle.png" }) {
      childImageSharp {
        gatsbyImageData(width: 400, placeholder: BLURRED)
      }
    }
  }
`;

export default CheckMath;
